import {Component} from 'react'

import './index.css'

class NotFound extends Component {
  render() {
    return (
      <div className="not-found-container">
        <h1 className="not-found-text">Page Not Found !!</h1>
      </div>
    )
  }
}
export default NotFound
